import { GenericLandingCard, GenericLandingCardHeader } from "../components";
import { GenericBackToBtn } from "../components/buttons";
import {
  buttonBackToLogin,
  expiredLinkSubTitle,
  expiredLinkTitle,
} from "../_constants";

export const ExpiredLinkPage = () => {
  return (
    <GenericLandingCard
      rightColumn={
        <GenericLandingCardHeader
          title={expiredLinkTitle}
          subtitle={expiredLinkSubTitle}
          gap={16}
        ></GenericLandingCardHeader>
      }
      leftInteraction={<GenericBackToBtn label={buttonBackToLogin} link="/" />}
    ></GenericLandingCard>
  );
};
